import { ReactElement } from "react";
import { WidgetTypes } from "../../../../services/http/widget/models/WidgetTypes";

const NoWidget = (widgetType: WidgetTypes): ReactElement =>
{
    return (
        <div>Body not found for widget type '{widgetType}'</div>
    );
}

export default NoWidget;